import BpkSectionHeader from '@skyscanner/backpack-web/bpk-component-section-header';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import MediaGrid from '../HotelMedia/MediaGrid';

import DescriptionContent from './DescriptionContent';

import type { Configs } from '@shared/types/configs';
import type { HotelDescription as HotelDescriptionType } from '@shared/types/hotel-content';
import type { I18nService } from '@shared/types/i18n';
import type { UserContext } from '@shared/types/user-context';

import STYLES from './HotelDescription.module.scss';

import { MEDIA_TYPE_HOTEL_DESCRIPTION } from '@hotels-hotel-detail/utils/hotel-images';
import AdaptiveImage from '@shared/ui/common/AdaptiveImage';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import { withI18n } from '@shared/ui/contexts/i18n';
import { withConfiguration } from '@shared/utils-frontend/contexts/ConfigurationContext';
import { withUserContext } from '@shared/utils-frontend/contexts/UserContext';

type Props = {
  hotelName: string;
  i18n: I18nService;
  hotelDescription: HotelDescriptionType;
  configs: Configs;
  userContext: UserContext;
};

const HotelDescription = ({
  configs: { enableHotelDescriptionSEOVariant },
  hotelDescription,
  hotelName,
  i18n,
  userContext: { enableSEOVariantHotelsDetailsPage },
}: Props) => (
  <div
    className={STYLES.HotelDescription}
    id="hotel-description"
    data-test-id="hotel-description"
  >
    <div className={STYLES.HotelDescription__header}>
      <BpkSectionHeader
        title={
          enableSEOVariantHotelsDetailsPage && enableHotelDescriptionSEOVariant
            ? i18n.translate(
                'HotelDescription_HDP_more_about_hotel_name',
                {
                  hotel_name: hotelName,
                },
                '@@',
                '@@',
              )
            : i18n.translate('GoodToKnow_descriptionHotel')
        }
      />
    </div>
    <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
      {(isMobile: boolean) => (
        <>
          <div className={STYLES.HotelDescription__mediaGrid}>
            {isMobile &&
              hotelDescription.images &&
              hotelDescription.images.length > 0 && (
                <AdaptiveImage
                  className={STYLES.HotelPreviewMobile}
                  src={hotelDescription.images[0].url}
                  width={350}
                  height={160}
                  altText=""
                />
              )}
            {!isMobile && (
              <MediaGrid mediaType={MEDIA_TYPE_HOTEL_DESCRIPTION} />
            )}
          </div>
          <BpkText
            textStyle={isMobile ? TEXT_STYLES.heading5 : TEXT_STYLES.heading3}
            tagName="p"
            className={STYLES.HotelDescription__hotelName}
          >
            {hotelName}
          </BpkText>
          <DescriptionContent
            hotelDescription={hotelDescription}
            isMobile={isMobile}
          />
        </>
      )}
    </BpkBreakpoint>
  </div>
);

export default withUserContext(withConfiguration(withI18n(HotelDescription)));
